import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PATHS } from "../../utils";
import * as image from "../../resources/images";
import SecHeader from "../base/SecHeader";
import PricingPlan from "./PricingPlan";
import UserDetail from "./UserDetail";
import PaymentModule from "./PaymentModule";
import { stripePlans } from "../../redux/actions/APIs";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const SubscriptionScreen = ({handleSubscribeBySignUp, isSubScribed, subscriptionPlan}) => {
  const dispatch = useDispatch();
  const {
      loggedInUser,
      planData,
      modalData,
      billingDetails,
    } = useSelector((state) => state.collections);
  const [selectedPlan, setSelectedPlan] = useState(); 
  const [step, setStep] = useState(1);
  const [getUserDetal, setUserDetail] = useState();
   const [planType, setPlanType]  = useState("monthly");
  useEffect(() => {
      if (!planData) {
        dispatch(stripePlans());
      }
    }, [planData]);
  
    const hanldeStep = (num , isNext)=>{
      if(billingDetails && isNext){
          setStep(3);
          return;
      }
      setStep(num);
    }

    useEffect(()=>{
      if(planData?.records?.length > 0 && subscriptionPlan){
          let myPlan = planData?.records?.find((item)=>item?.planType === subscriptionPlan)
          if(myPlan){
             setSelectedPlan(myPlan);
             setPlanType(myPlan?.type);
             setStep(2);
          }
         
      }
    },[planData])

    

  useEffect(() => {
	  window.scrollTo(0, 0);
	}, [step]);

  // console.log("hanldeStep : ", planData,billingDetails, selectedPlan );
  
  return (
    <div className="RootContent">
      <div className="hubSpotthemeSec">
        <SecHeader />
        <div className="content-wrapper container-fluid">
          <div className="contentContainer">
            {step === 1 && (
              <PricingPlan 
                setSelectedPlan={setSelectedPlan}
                selectedPlan={selectedPlan}
                hanldeStep={hanldeStep}
                planDataArr={planData?.records}
                planType={planType}
                setPlanType={setPlanType}
              />
            )}
            
            {step === 2 && (
              <Elements stripe={stripePromise}>
                 <UserDetail 
                    hanldeStep={hanldeStep}
                    selectedPlan={selectedPlan}
              />
              </Elements >
            )}

           {step === 3 && (
              <PaymentModule 
                hanldeStep={hanldeStep}
                mySelectedPlan={selectedPlan}
                handleSubscribeBySignUp={handleSubscribeBySignUp}
                isSubScribed={isSubScribed}
              />
           )}
           
            
          </div>

        </div>

        <div class="footer-area">
          <div class="container">
            <div class="row">
              <div class="col-lg-3 col-md-3">
                <div class="single-footer-widget">
                  <a class="logo" href="https://softwarehouse.today/projects/bloomster/">
                    <img src="https://softwarehouse.today/projects/bloomster/wp-content/uploads/2025/04/bloomster-logo-updated.png" alt="Bloomster" />
                  </a>
                  <p>With so much to do, we know your children come first. Let Bloomster help with fun, engaging educational videos, so you can tackle the rest while supporting them.</p>
                </div>
              </div>
              <div class="single-footer-widget col-lg-3 col-md-3 widget_nav_menu">
                <h3>Quick Links</h3><div class="menu-quick-links-container">
                  <ul id="menu-quick-links" class="">
                    <li id="menu-item-6583" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6583"><a href="https://bloomster.com/course-library">Courses</a></li>
                    <li id="menu-item-7561" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7561"><a href="https://bloomster.com/online-platform">How Bloomster Works</a></li>
                    <li id="menu-item-6585" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6585"><a href="https://bloomster.com/pricing">Pricing</a></li>
                    <li id="menu-item-6586" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6586"><a href="https://bloomster.com/classroom">Bloomster for Schools</a></li>
                  </ul>
                </div>
              </div>
              <div class="single-footer-widget col-lg-3 col-md-3 widget_nav_menu"><h3>Resources</h3>
                <div class="menu-resources-container"><ul id="menu-resources" class="">
                  <li id="menu-item-7560" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7560"><a href="https://bloomster.com/about-us">About Us</a></li>
                  <li id="menu-item-6587" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6587"><a href="https://bloomster.com/blog">Blog</a></li>
                  <li id="menu-item-6588" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6588"><a href="https://bloomster.com/ebook-library">eBook Library</a></li>
                  <li id="menu-item-6589" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6589"><a href="https://bloomster.com/app">Mobile App</a></li>
                  <li id="menu-item-7559" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-7538 current_page_item menu-item-7559"><a href="https://bloomster.com/contact-us" aria-current="page">Contact Us</a></li>
                </ul></div></div>
              <div class="single-footer-widget col-lg-3 col-md-3 widget_ecademy_contact_info"><h3>Contact Information</h3>
                <ul class="footer-contact-info">
                  <li><i class="fa-regular fa-envelope"></i> <a href="mailto:contact@bloomster.com">contact@bloomster.com</a>  </li>
                </ul>
                <ul class="social-link">
                  <li>
                    <a class="d-block facebook" target="_blank" href="https://www.facebook.com/bloomsterlearning"> <i class="fa-brands fa-facebook-f"></i></a>
                  </li>
                  <li>
                    <a class="d-block instagram" target="_blank" href="https://www.instagram.com/bloomsterlearning"> <i class="fa-brands fa-instagram"></i></a>
                  </li>
                  <li>
                    <a class="d-block" target="_blank" href="https://www.linkedin.com/company/bloomsterlearning"> <i class="fa-brands fa-linkedin-in"></i></a>
                  </li>
                  <li>
                    <a class="d-block" target="_blank" href="https://www.tiktok.com/@bloomster.learning"> <i class="fa-brands fa-tiktok"></i></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="footer-bottom-area">
              <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                  <p>2025 Bloomster. All Rights Reserved.</p>
                </div>

                <div class="col-lg-6 col-md-6">
                  <ul id="menu-footer-menu" class=""><li id="menu-item-6581" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6581"><a href="https://bloomster.com/termsandprivacypolicy">Privacy Policy</a></li>
                    <li id="menu-item-6582" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6582"><a href="https://bloomster.com/termsandprivacypolicy">Terms of Use</a></li>
                  </ul>								</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default SubscriptionScreen;